import React, { useState, useEffect, useMemo } from 'react'

import useLoginValidation from 'components/Auth/AuthForms/hooks/useLoginValidation'
import { isEmpty } from 'helpers/lodash'
import { getQueryParams } from 'helpers/urls'
import useCountdownTimer from 'hooks/useCountdownTimer'

import * as LoginFormStyles from './styles'

import useLoginOtp from '../hooks/useLoginOtp'
import * as AuthFormStyles from '../styles'

const numberRegex = /^\d+$/

const LoginForm = () => {
    const [phoneNumber, setPhoneNumber] = useState('')
    const [isOtpInputActive, setIsOtpInputActive] = useState(false)
    const [otp, setOtp] = useState('')

    const otpButtonRef = React.useRef(null)
    const loginButtonRef = React.useRef(null)

    const { isOTPValid, isPhoneValid } = useLoginValidation(phoneNumber, otp)
    const { sendOtp, otpSending, verifyOtp, otpVerifying } = useLoginOtp()
    const { timeLeft, timerActive, startCountdown } = useCountdownTimer(30)

    useEffect(() => {
        otpSending && startCountdown()
        // eslint-disable-next-line
    }, [otpSending])

    const handleMobileInputKeyPress = e => {
        if (e.key === 'Enter' && otpButtonRef?.current) {
            otpButtonRef.current.click()
        }
    }

    const handleOTPInputKeyPress = e => {
        if (e.key === 'Enter' && loginButtonRef?.current) {
            loginButtonRef.current.click()
        }
    }

    const onMobileChange = e => {
        const value = e.target.value
        if (isEmpty(value) || (numberRegex.test(value) && value.length <= 10)) {
            setPhoneNumber(value)
        }
    }

    const onOTPChange = e => {
        const value = e.target.value
        if (isEmpty(value) || (numberRegex.test(value) && value.length <= 6)) {
            setOtp(value)
        }
    }

    const redirectUrl = useMemo(() => {
        let redirect = '/signup'
        const { next, source } = getQueryParams()
        if (!isEmpty(source)) redirect += `?source=${source}`
        if (!isEmpty(next)) redirect += `?next=${next}`
        return redirect
    }, [])

    return (
        <AuthFormStyles.Wrapper>
            <AuthFormStyles.Title>
                <AuthFormStyles.Orange>oh. </AuthFormStyles.Orange>
                you are back!
            </AuthFormStyles.Title>
            <AuthFormStyles.Spam>{`it's been a while`}</AuthFormStyles.Spam>
            <AuthFormStyles.FormWrapper>
                <AuthFormStyles.MobileNumberBox>
                    <LoginFormStyles.LoginMobileInput
                        invalid={!isPhoneValid && phoneNumber.length !== 0}
                        onChange={onMobileChange}
                        onKeyDown={handleMobileInputKeyPress}
                        value={phoneNumber}
                        placeholder="phone number"
                        pattern="[0-9]*"
                        type="tel"
                    />
                    <AuthFormStyles.OtpButton
                        ref={otpButtonRef}
                        isDisabled={timerActive || !isPhoneValid}
                        onClick={() => {
                            console.log('otp sending')
                            !otpSending && sendOtp(phoneNumber)
                            setIsOtpInputActive(true)
                        }}
                    >
                        {timerActive ? `resend ${timeLeft}` : 'send OTP'}
                    </AuthFormStyles.OtpButton>
                </AuthFormStyles.MobileNumberBox>
                {!isPhoneValid && phoneNumber.length !== 0 && (
                    <AuthFormStyles.MobileInputValidation invalid={true}>
                        please use 10 digit valid mobile number
                    </AuthFormStyles.MobileInputValidation>
                )}
                {isOtpInputActive && (
                    <>
                        <AuthFormStyles.OtpInput
                            invalid={!isOTPValid && otp.length !== 0}
                            disabled={!isOtpInputActive}
                            onChange={onOTPChange}
                            onKeyDown={handleOTPInputKeyPress}
                            value={otp}
                            placeholder="enter otp"
                            pattern="[0-9]*"
                            type="tel"
                        />
                        {!isOTPValid && otp.length !== 0 && (
                            <AuthFormStyles.OTPValidation invalid={true}>
                                please use 6 digit OTP which you have received
                            </AuthFormStyles.OTPValidation>
                        )}

                        <AuthFormStyles.LoginButton
                            ref={loginButtonRef}
                            isDisabled={
                                !isOTPValid || !isPhoneValid || otpVerifying
                            }
                            onClick={() => verifyOtp(phoneNumber, otp)}
                        >
                            {otpVerifying ? 'getting you in...' : 'sign in'}
                        </AuthFormStyles.LoginButton>
                    </>
                )}
                <AuthFormStyles.Signup>
                    not a registered user?
                    <AuthFormStyles.StyledLink to={redirectUrl}>
                        <AuthFormStyles.SignupLink>
                            sign up
                            <AuthFormStyles.RightArrow />
                        </AuthFormStyles.SignupLink>
                    </AuthFormStyles.StyledLink>
                </AuthFormStyles.Signup>
            </AuthFormStyles.FormWrapper>
        </AuthFormStyles.Wrapper>
    )
}

export default LoginForm
